import React, { ReactNode } from 'react';
import './LeftPanelVisualizer.scss';

export interface LeftPanelVisualizerProps {
  contentType?: 'markdown' | 'json' | 'component';
  data?: string | ReactNode;
  isPreview?: boolean;
  isEditMode?: boolean;
  onDataChange?: (newData: string) => void;
}

const LeftPanelVisualizer: React.FC<LeftPanelVisualizerProps> = ({
  contentType = 'markdown',
  data = '',
  isPreview = false,
  isEditMode = false,
  onDataChange,
}) => {
  const renderContent = () => {
    if (contentType === 'component' && React.isValidElement(data)) {
      return data;
    }

    if (contentType === 'json') {
      try {
        const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
        if (isEditMode && onDataChange) {
          return (
            <textarea
              className="left-panel-visualizer__json-editor"
              value={JSON.stringify(jsonData, null, 2)}
              onChange={e => onDataChange(e.target.value)}
              placeholder="Enter JSON data..."
            />
          );
        }
        return <pre className="left-panel-visualizer__json-viewer">{JSON.stringify(jsonData, null, 2)}</pre>;
      } catch (e) {
        console.error('JSON parse error:', e);
        return <div className="left-panel-visualizer__error">Invalid JSON</div>;
      }
    }

    // Default to markdown/text
    if (isEditMode && onDataChange) {
      const textValue = typeof data === 'string' ? data : '';
      return (
        <textarea
          className="left-panel-visualizer__text-editor"
          value={textValue}
          onChange={e => onDataChange(e.target.value)}
          placeholder="Enter variable content..."
        />
      );
    }
    return <div className="left-panel-visualizer__markdown-viewer">{typeof data === 'string' ? data : ''}</div>;
  };

  const visualizerClassName = `left-panel-visualizer ${isPreview ? 'left-panel-visualizer--preview' : ''}`;

  return <div className={visualizerClassName}>{renderContent()}</div>;
};

export default LeftPanelVisualizer;
